import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useSearchParams } from 'react-router-dom';
import JobPortalHeader from '../components/JobPortal/JobPortalHeader';
import Footer from '../components/Footer';
import { FileText, Shield, Cookie, ChevronRight } from 'lucide-react';

const JobLegal: React.FC = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || 'terms';
    const [content, setContent] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const { t, t_api } = useLanguage();

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const res = await fetch('/api/content/Careers_Portal');
                if (res.ok) {
                    const data = await res.json();
                    setContent(data);
                }
            } catch (err) {
                console.error("Legal content fetch failed", err);
            } finally {
                setLoading(false);
            }
        };
        fetchContent();
        window.scrollTo(0, 0);
    }, [type]);

    const getDisplayInfo = () => {
        switch (type) {
            case 'privacy':
                return {
                    title: t('legal.privacy'),
                    icon: Shield,
                    color: 'blue',
                    text: content.legal_privacy || 'Privacy Policy for Hamdan Trading Group...'
                };
            case 'cookie':
                return {
                    title: t('legal.cookie'),
                    icon: Cookie,
                    color: 'amber',
                    text: content.legal_cookie || 'Cookie Policy for Hamdan Trading Group...'
                };
            default:
                return {
                    title: t('legal.terms'),
                    icon: FileText,
                    color: 'red',
                    text: content.legal_terms || 'Terms and Conditions for Hamdan Trading Group...'
                };
        }
    };

    const info = getDisplayInfo();

    return (
        <div className="min-h-screen bg-white flex flex-col font-sans pt-20">
            <JobPortalHeader />

            <main className="flex-1">
                {/* Hero Header */}
                <div className="bg-slate-50 py-20 px-6 border-b border-slate-100">
                    <div className="max-w-4xl mx-auto">
                        <div className="flex items-center gap-3 text-red-600 font-black uppercase tracking-[0.2em] text-[10px] mb-4">
                            <span>{t('nav.careers')}</span>
                            <ChevronRight className="w-3 h-3" />
                            <span>{t('legal.title')}</span>
                        </div>
                        <h1 className="text-3xl font-black text-slate-900 uppercase tracking-tight">
                            {info.title}
                        </h1>
                    </div>
                </div>

                {/* Content */}
                <div className="max-w-4xl mx-auto py-20 px-6">
                    <div className="bg-white">
                        <div className="flex items-center gap-4 mb-10">
                            <div className={`w-12 h-12 bg-${info.color}-50 text-${info.color}-600 rounded-2xl flex items-center justify-center`}>
                                <info.icon className="w-6 h-6" />
                            </div>
                            <div>
                                <h2 className="text-xl font-black text-slate-800 uppercase tracking-tight">{t('legal.statement')}</h2>
                                <p className="text-xs text-slate-400 font-bold uppercase tracking-widest">{t('legal.last_updated')}: {new Date().toLocaleDateString()}</p>
                            </div>
                        </div>

                        <div className="prose prose-slate max-w-none">
                            <div className="text-slate-600 leading-relaxed font-medium whitespace-pre-line text-lg">
                                {loading ? t('common.loading') : t_api(info.text)}
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default JobLegal;
